import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-employee-report',
  standalone: true,
  imports: [LoaderComponent,CommonModule],
  templateUrl: './employee-report.component.html',
  styleUrl: './employee-report.component.scss'
})
export class EmployeeReportComponent {
  isDisabled: boolean = false;
  menus = [] as any;

  constructor(
    private userright: UserRightService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.ESS_ProfileMenuRightsView();
  }

  ESS_ProfileMenuRightsView() {
    this.userright.ESS_ProfileMenuRightsView({ SelectType: 'View' }).subscribe({
      next: (response) => {
        try {
          this.menus = response.filter((e:any) => e.ESS_MenuMasterId == 80)[0];
        } catch (e) { this.menus = [] }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  ReportPage(url:String){
    this.router.navigate([url]);
  }
}
